import React, { useEffect, useMemo, useRef, useState } from "react";
import styled, { css } from "styled-components";
import { dataDetail, ID_PRIZE } from "./DefineData";
import { mediaQueryPoint, useMediaQuery } from "../../../../utils/hooks";
import bgImg from "../../../../assets/images/Mini-Game/Frame-56-tiny.png";
import bgTakePrize from "../../../../assets/images/Mini-Game/bg-btn-intro.png";
import imgHeader from "../../../../assets/images/Mini-Game/img-header-takeprize.png";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import ActionComponent from "./Action";
import { curStateAccount, curStateMiniGame } from "../../../../Redux/selector";
import _ from "lodash";
import {
  getDataAwardListMiniGame,
  setDataPopupError,
  setOpenPopupChangeCoinsSuccess,
  setOpenPopupLogin,
  setOpenPopupPuzzle,
} from "../../../../Redux/futures/mini-game/action";
import { deleteItemCookie } from "../../../../utils/cookie";
import { postDataApi } from "../../../../config/service";
import API_PATH from "../../../../config/API_PATH";
import runOut from "../../../../assets/images/Mini-Game/take-prize-run-out.png";
import runOutEn from "../../../../assets/images/Mini-Game/take-prize-run-out-en.png";
import iconSuperPrize from "../../../../assets/images/Mini-Game/icon-piece-super.png";
import { ID_HIDDEN_POPUP_INTRO_GIFT } from "../../../../helper/const";

export default function DetailProduct({
  itemProductActive,
  dataAwardActive,
  setDataAwardActive,
  handleShowDetailItem,
  isRunout = false,
  setIsTake = () => { }
}) {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const dataMiniGame = useSelector(curStateMiniGame);
  const selectorAccount = useSelector(curStateAccount);
  const [dataAwardApi, setDataAwardApi] = useState(null);
  const { dataPrizeCollectionMini, dataPieceCollectedMini, dataAwardListMini } =
    dataMiniGame;

  const renderProduct = useMemo(() => {
    if (_.isEmpty(dataAwardListMini)) {
      return "";
    }
    let title = "";
    let isRunout = false;
    let isSuperPrize = false;
    const activeProduct = dataAwardListMini.find(
      (item) => +item.id === +itemProductActive
    );

    if (activeProduct) {
      title = activeProduct.name;
      isRunout = +activeProduct.total_num === +activeProduct.received_num;
      isSuperPrize = +activeProduct.is_super_prize === 1;
    }

    return {
      title,
      isRunout,
      isSuperPrize,
    };
  }, [itemProductActive, dataAwardListMini]);

  const { dataDetail, isTakePrize } = useMemo(() => {
    const data = dataAwardActive;

    if (_.isEmpty(data)) {
      return { dataDetail: [{ srcImg: [] }], isTakePrize: false };
    }

    const sortData = data.sort((a, b) => +a.position - Number(b.position));

    let isTakePrize = true;

    const formatData = sortData.map((item) => {
      if (!item.num) {
        isTakePrize = false;
      }
      return {
        ...item,
        src: item.image_light,
        idPiece: item.id,
      };
    });
    setIsTake(isTakePrize)
    return { dataDetail: [{ srcImg: formatData }], isTakePrize };
  }, [itemProductActive, dataAwardActive, dataAwardApi]);

  const handleTakePrize = async () => {
    if (!isTakePrize) {
      return null;
    }

    if (!selectorAccount.userInfo) {
      return dispatch(setOpenPopupLogin(true));
    }

    const dataApi = await postDataApi(API_PATH.miniGameTakePrize, {
      award_id: itemProductActive,
    });

    if (!dataApi?.success) {
      return dispatch(
        setDataPopupError({
          isOpen: true,
          message: dataApi?.errorMessage,
        })
      );
    }

    const dataAward = dataMiniGame.dataAwardListMini.find(
      (item) => +item?.id === +itemProductActive
    );

    // thành công
    setDataAwardApi(dataApi.data);
    dispatch(
      setOpenPopupPuzzle({
        isShow: true,
        data: { prizeName: dataAward.name, image: dataAward.image },
      })
    );
    deleteItemCookie(ID_HIDDEN_POPUP_INTRO_GIFT)
    dispatch(getDataAwardListMiniGame());
  };

  const bg_lang_runOut = i18n.length === 'en' ? runOutEn : runOut

  return (
    <>
      <ActionComponent />
      <ContainerDetail>
        <img src={bgImg} className="img-bg" />
        <div className="img-header-takeprize-mini">
          <img src={imgHeader} alt="" />
          <div className="content-detail shrikhand-regular m-0 p-0">
            {renderProduct.title}
          </div>
        </div>
        {renderProduct.isSuperPrize ? (
          <img src={iconSuperPrize} alt="" className="icon-super-prize" />
        ) : null}
        <div className="content-product">
          {/* <WinnerComponent /> */}
          <div className="main-content">
            <div className="container-main__content">
              {dataDetail.map((item) => {
                if (
                  item?.srcImg?.length === 4
                  // item.id === ID_PRIZE.prize_7
                ) {
                  return (
                    <ContainerPiece
                      quantityItem={item?.srcImg?.length > 4 ? 3 : 2}
                      key={item.id}
                      className={`main-content__container ${renderProduct.isRunout ? "runout" : ""
                        }`}
                    >
                      {item.srcImg.map((itemImg, index) => {
                        return (
                          <div
                            key={`src_${item.id}_${index}`}
                            className="item-img__piece"
                          >
                            <div
                              className={`img-child__${index + 1
                                } position-relative`}
                            >
                              <div className="position-relative w-max">
                                <div
                                  className="deleted"
                                  onClick={() => handleShowDetailItem(itemImg)}
                                />
                                <img
                                  src={itemImg.src}
                                  alt="img-piece"
                                  className={`${!itemImg.num ? "img-brightness" : ""
                                    }`}
                                />
                              </div>
                            </div>
                          </div>
                        );
                      })}
                      {renderProduct.isRunout ? (
                        <img src={bg_lang_runOut} alt="" className="runout-img" />
                      ) : null}
                    </ContainerPiece>
                  );
                }

                if (
                  // item.id === ID_PRIZE.prize_6 ||
                  // item.id === ID_PRIZE.prize_7
                  item?.srcImg?.length === 9
                ) {
                  return (
                    <ContainerPiece1
                      className={`main-content__container ${renderProduct.isRunout ? "runout" : ""
                        }`}
                    >
                      {item.srcImg.map((itemImg, index) => {
                        return (
                          <div
                            key={`src_${index}`}
                            className="item-img__piece height-178px"
                          >
                            <div
                              className={`position-relative img-child2__${index + 1
                                }`}
                            >
                              <div className="position-relative w-max">
                                <div
                                  className="deleted"
                                  onClick={() => handleShowDetailItem(itemImg)}
                                />
                                <img
                                  src={itemImg.src}
                                  alt="img-piece"
                                  className={`${!itemImg.num ? "img-brightness" : ""
                                    }`}
                                />
                              </div>
                            </div>
                          </div>
                        );
                      })}
                      {renderProduct.isRunout ? (
                        <img src={bg_lang_runOut} alt="" className="runout-img" />
                      ) : null}
                    </ContainerPiece1>
                  );
                }

                if (
                  // item.id === ID_PRIZE.prize_8
                  item?.srcImg?.length > 9
                ) {
                  return (
                    <ContainerPiece3
                      quantityItem={item?.quantityColumns || 3}
                      key={item.id}
                      isRunOut={isRunout}
                      className={`main-content__container special-product ${renderProduct.isRunout ? "runout" : ""
                        }`}
                    >
                      {item.srcImg.map((itemImg, index) => {
                        return (
                          <div
                            key={`src_${index}`}
                            className="item-img__piece height-178px"
                          >
                            <div
                              className={`position-relative img-child2__${index + 1
                                }`}
                            >
                              <div className="position-relative w-max">
                                <div
                                  className="deleted"
                                  onClick={() => handleShowDetailItem(itemImg)}
                                />
                                <img
                                  src={itemImg.src}
                                  alt="img-piece"
                                  className={`${!itemImg.num ? "img-brightness" : ""
                                    }`}
                                />
                              </div>
                            </div>
                          </div>
                        );
                      })}

                      {renderProduct.isRunout ? (
                        <img src={bg_lang_runOut} alt="" className="runout-img" />
                      ) : null}
                    </ContainerPiece3>
                  );
                }

                return (
                  <ContainerPiece2
                    className={`main-content__container ${renderProduct.isRunout ? "runout" : ""
                      }`}
                    quantityItem={item?.quantityColumns || 3}
                    key={item.id}
                  >
                    {item.srcImg.map((itemImg, index) => {
                      return (
                        <div
                          key={`src_${index}`}
                          className={`item-img__piece height-178px ${item.id === 5 ? "item-img__piece_5" : ""
                            }`}
                        >
                          <div
                            className={`position-relative img-child2__${index + 1
                              }`}
                          >
                            <div className="position-relative w-max">
                              <div
                                className="deleted"
                                onClick={() => handleShowDetailItem(itemImg)}
                              />
                              <img
                                src={itemImg.src}
                                alt="img-piece"
                                className={`${!itemImg.num ? "img-brightness" : ""
                                  }`}
                              />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                    {renderProduct.isRunout ? (
                      <img src={bg_lang_runOut} alt="" className="runout-img" />
                    ) : null}
                  </ContainerPiece2>
                );
              })}
            </div>
            <div className="content-active">
              <div
                className={` ${dataDetail[0]?.srcImg?.length === 4 ||
                  dataDetail[0]?.srcImg?.length === 9
                  ? // ||
                  // filterData.data[0]?.id === ID_PRIZE.prize_6 7 1
                  "content-container-prize1"
                  : "content-container-prize"
                  } ${
                  // filterData.data[0]?.id === ID_PRIZE.prize_6 ||
                  // filterData.data[0]?.id === ID_PRIZE.prize_7
                  dataDetail[0]?.srcImg?.length === 9
                    ? "content-container-prize-5"
                    : dataDetail[0]?.srcImg?.length === 12
                      ? "content-container-prize-8"
                      : ""
                  }`}
              ></div>
            </div>
            <div
              className={`container-bg-take-prize scale-hover-item ${!isTakePrize ? "opcity-06" : ""
                }`}
            >
              <div className="take-prize-main" onClick={handleTakePrize}>
                <img src={bgTakePrize} alt="" className="bg-take-prize" />
                <div className="content-bg-take-prize">{t('mini_game.homepage.take_prize')}</div>
              </div>
            </div>
          </div>
        </div>
      </ContainerDetail>
    </>
  );
}

const cssBefore = css`
  content: "";
  position: absolute;
  width: calc(100% + 2px);
  height: 100%;
  z-index: 2;
  pointer-events: none;
`;

const ContainerPiece3 = styled.div`
  display: grid;
  grid-template-columns: calc(50% - 154px) 154px 154px calc(50% - 154px);
  /* mask-image: linear-gradient(black, transparent); */

  .w-max {
    width: max-content;
  }

  .img-child2__12 {
    .w-max::before {
      ${cssBefore};
      border-bottom-right-radius: 5px;
      border-bottom: 4px solid white;
    }
  }

  .img-child2__11,
  .img-child2__10 {
    .w-max::before {
      ${cssBefore};
      border-bottom: 4px solid white;
    }
  }

  .img-child2__9 {
    .w-max::before {
      ${cssBefore};
      border-bottom-left-radius: 5px;
      border-left: 4px solid white;
      border-bottom: 4px solid white;
    }
  }

  .img-child2__1 {
    .w-max::before {
      ${cssBefore};
      border-top-left-radius: 5px;
      border-left: 4px solid white;
      border-top: 4px solid white;
    }
  }

  .img-child2__2,
  .img-child2__3,
  .img-child2__4 {
    .w-max::before {
      ${cssBefore};
      border-top: 4px solid white;
    }
  }

  .img-child2__4 .w-max::before {
    border-top-right-radius: 5px;
  }

  .img-child2__5 {
    .w-max::before {
      ${cssBefore};
      border-left: 4px solid white;
    }
  }

  .img-child2__4,
  .img-child2__8,
  .img-child2__12 {
    .w-max::before {
      ${cssBefore};
      border-right: 4px solid white;
      left: -2px;
    }
  }

  .img-child2__2,
  .img-child2__3,
  .img-child2__6,
  .img-child2__7,
  .img-child2__10,
  .img-child2__11 {
    display: flex;
    justify-content: center;
    .w-max::before {
      left: -2px;
    }
  }

  .img-child2__1,
  .img-child2__5,
  .img-child2__9 {
    display: flex;
    justify-content: end;
    position: relative;
    .w-max::before {
      left: -2px;
    }
  }

  .img-child2__9 {
    left: 57px;
  }

  .img-child2__9,
  .img-child2__11 {
    position: relative;
    top: -58px;
  }

  .img-child2__10,
  .img-child2__12 {
    top: -74px;
    position: relative;
  }

  .img-child2__12 {
    left: -40px;
  }

  .img-child2__4,
  .img-child2__8,
  .img-child2__12 {
    display: flex;
    justify-content: start;
  }

  .img-child2__2,
  .img-child2__6,
  .img-child2__10 {
    right: -20px;
  }

  .img-child2__3,
  .img-child2__7,
  .img-child2__11 {
    left: -19px;
  }

  .img-child2__1 {
    right: -58px;
  }

  .img-child2__4 {
    left: -40px;
  }

  .img-child2__5,
  .img-child2__7 {
    top: -37px;
  }

  .img-child2__6,
  .img-child2__8 {
    top: -21px;
  }

  .img-child2__5 {
    right: -41px;
  }
  .img-child2__8 {
    left: -56px;
  }
  @media (max-width: 576px) {
    scale: 0.65;
    padding-top: 0 !important;
    margin-top: -35px;
    margin-bottom: -20px;

      .img-child2__5,   .img-child2__7 {
        top: -36px !important;
    }

      .img-child2__6,   .img-child2__8 {
       top: -20px !important; 
     }
      .img-child2__9,  .img-child2__11 {
        top: -57px !important;
     }
  }
`;

const ContainerPiece1 = styled.div`
  display: grid;
  grid-template-columns: calc(50% - 100px) 200px calc(50% - 100px);

  .w-max {
    width: max-content;
  }

  .img-child2__2,
  .img-child2__5,
  .img-child2__8 {
    display: flex;
    justify-content: center;
  }

  .img-child2__1,
  .img-child2__4,
  .img-child2__7 {
    display: flex;
    justify-content: right;
  }

  .img-child2__3,
  .img-child2__6,
  .img-child2__9 {
    display: flex;
    justify-content: left;
  }

  .img-child2__1 {
    right: -46px;
  }

  .img-child2__3 {
    left: -46px;
  }

  .img-child2__4 {
    right: -25px;
  }

  .img-child2__4,
  .img-child2__6 {
    top: -47.5px;
  }

  .img-child2__7,
  .img-child2__9 {
    top: -73px;
  }

  .img-child2__8 {
    top: -95px;
  }
  .img-child2__9 {
    left: -46px;
  }

  .img-child2__7 {
    right: -46px;
  }

  .img-child2__6 {
    left: -45px;
  }

  .img-child2__5 {
    top: -26.5px;
  }

  .img-child2__1 .w-max::before,
  .img-child2__2 .w-max::before,
  .img-child2__3 .w-max::before,
  .img-child2__4 .w-max::before,
  .img-child2__5 .w-max::before,
  .img-child2__6 .w-max::before,
  .img-child2__7 .w-max::before,
  .img-child2__8 .w-max::before,
  .img-child2__9 .w-max::before {
    ${cssBefore};
    border: 4px solid white;
    border-radius: 5px;
    left: -2px;
  }

  .img-child2__7 .w-max::before,
  .img-child2__8 .w-max::before,
  .img-child2__9 .w-max::before {
    bottom: 4px;
    pointer-events: none;
  }

  .img-child2__3 .w-max::before,
  .img-child2__6 .w-max::before,
  .img-child2__9 .w-max::before {
    right: 0;
    pointer-events: none;
  }

  .img-child2__1,
  .img-child2__2,
  .img-child2__4,
  .img-child2__5,
  .img-child2__7,
  .img-child2__8 {
    .w-max::before {
      border-right: 0px;
      pointer-events: none;
    }
  }

  .img-child2__2,
  .img-child2__3,
  .img-child2__5,
  .img-child2__6,
  .img-child2__8,
  .img-child2__9 {
    .w-max::before {
      border-left: 0px;
      pointer-events: none;
    }
  }

  .img-child2__5 {
    left: 0px;
    img {
      max-width: max-content;
    }
  }

  .img-child2__1,
  .img-child2__2,
  .img-child2__3,
  .img-child2__5,
  .img-child2__6,
  .img-child2__4 {
    .w-max::before {
      border-bottom: 0px;
      height: calc(100%);
      pointer-events: none;
    }
  }

  .img-child2__4,
  .img-child2__5,
  .img-child2__6 {
    .w-max::before {
      border-top: 0;
      bottom: 2px;
      pointer-events: none;
    }
  }

  .item-img__piece_5 .img-child2__5 {
    .w-max::before {
      border-top: 0;
      bottom: 3px;
      pointer-events: none;
    }
  }

  .item-img__piece_5 .img-child2__6 {
    .w-max::before {
      border-top: 0;
      left: -2px;
      pointer-events: none;
    }
  }

  .img-child2__7,
  .img-child2__8,
  .img-child2__9 {
    .w-max::before {
      border-top: 0px;
      pointer-events: none;
    }
  }

  .img-child2__6 {
    left: -25px;
  }

  @media (max-width: 576px) {
    scale: 0.7;
    padding-top: 0 !important;
    margin-top: -40px;
    margin-bottom: 20px;
  }

  @media (max-width: 450px) {
    scale: 0.6;
  }
`;

const ContainerPiece = styled.div`
  display: grid;
  grid-template-columns: repeat(${(props) => props.quantityItem}, 1fr);

  .w-max {
    width: max-content;
  }

  .item-img__piece {
    position: relative;
    width: 100%;
    height: 300px;

    .img-child__1,
    .img-child__3 {
      display: flex;
      justify-content: right;
    }

    .img-child__3 {
      right: 32px;
      top: -99px;
      .position-relative {
        width: max-content;
      }
    }

    .img-child__1 {
      right: -38px;
    }

    .img-child__3 {
      right: -6px;
    }
    .img-child__4 {
      top: -67px;
      left: -32px;
    }

    .img-child__1 .w-max::before,
    .img-child__2 .w-max::before,
    .img-child__3 .w-max::before,
    .img-child__4 .w-max::before {
      ${cssBefore};
      width: 100%;
      border: 4px solid white;
      border-radius: 5px;
      left: -2px;
    }

    .img-child__1 .w-max::before {
      border-right: 0px;
      border-bottom: 0px;
      pointer-events: none;
    }

    .img-child__2 .w-max::before {
      border-left: 0px;
      border-bottom: 0px;
      pointer-events: none;
    }

    .img-child__3 .w-max::before {
      border-right: 0px;
      border-top: 0px;
      bottom: 3px;
      pointer-events: none;
    }

    .img-child__4 .w-max::before {
      border-left: 0px;
      border-top: 0px;
      bottom: 3px;
      pointer-events: none;
    }
  }

  .height-178px {
    height: 178px;
  }
  .img-child2__1,
  .img-child2__4 {
    display: flex;
    justify-content: right;
  }

  .img-child2__3,
  .img-child2__6 {
    display: flex;
    justify-content: left;
  }

  .img-child2__1 {
    right: -39px;
  }
  .img-child2__3 {
    left: -39px;
  }

  @media (max-width: 768px) {
    scale: 0.8;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin: 0 auto;
    padding-top: 0;
    margin-top: -40px;
  }

  @media (max-width: 576px) {
    scale: 0.5;
    margin-top: -110px;
    padding-top: 0 !important;
    margin-bottom: -25px;
  }
`;

const ContainerPiece2 = styled.div`
  display: grid;
  grid-template-columns: calc(50% - 100px) 200px calc(50% - 100px);
  margin: 0 auto;
  margin-top: 50px;
  max-width: 804px;
  justify-content: center;

  .w-max::after {
    bottom: 6px !important;
    border-radius: 5px;
    pointer-events: none;
  }

  .w-max {
    width: max-content;
  }

  .img-child2__2,
  .img-child2__5 {
    display: flex;
    justify-content: center;
  }

  .img-child2__1,
  .img-child2__4 {
    display: flex;
    justify-content: right;
  }

  .img-child2__3,
  .img-child2__6 {
    display: flex;
    justify-content: left;
  }

  .img-child2__1 {
    right: -25px;
  }

  .img-child2__3 {
    left: -24px;
  }

  .img-child2__4 {
    right: -46px;
  }

  .img-child2__4,
  .img-child2__6 {
    top: -25px;
  }

  .img-child2__6 {
    left: -45px;
  }

  .img-child2__5 {
    top: -46px;
  }

  .img-child2__1 .w-max::before,
  .img-child2__2 .w-max::before,
  .img-child2__3 .w-max::before,
  .img-child2__4 .w-max::before,
  .img-child2__5 .w-max::before,
  .img-child2__6 .w-max::before {
    ${cssBefore};
    border: 4px solid white;
    border-radius: 5px;
    left: -1px;
    right: -1px;
  }

  .img-child2__1,
  .img-child2__2,
  .img-child2__4,
  .img-child2__5 {
    .w-max::before {
      border-right: 0px;
      pointer-events: none;
    }
  }

  .img-child2__2,
  .img-child2__3,
  .img-child2__5,
  .img-child2__6 {
    .w-max::before {
      border-left: 0px;
      pointer-events: none;
    }
  }

  .img-child2__1,
  .img-child2__2,
  .img-child2__3 {
    .w-max::before {
      border-bottom: 0px;
      height: calc(100%);
      pointer-events: none;
    }
  }

  .img-child2__4,
  .img-child2__5,
  .img-child2__6 {
    .w-max::before {
      border-top: 0;
      bottom: 2px;
      pointer-events: none;
    }
  }

  .item-img__piece_5 .img-child2__5 {
    .w-max::before {
      border-top: 0;
      bottom: 3px;
      pointer-events: none;
    }
  }

  .item-img__piece_5 .img-child2__3 {
    left: -24.5px;
  }

  .item-img__piece_5 .img-child2__6 {
    left: -46px;
  }

  .item-img__piece_5 .img-child2__6 {
    .w-max::before {
      border-top: 0;
      left: -2px;
      pointer-events: none;
    }
  }

  @media (max-width: 576px) {
    justify-content: center;
    margin: 0 auto;
    scale: 0.7;
    margin-bottom: -70px;
    padding-top: 0 !important;

    .img-child2__1 {
      right: -23px;
    }
    .img-child2__3 {
      left: -23px;
    }

    .img-child2__4 {
      right: -44px;
    }

    .img-child2__6 {
      left: -44px;
    }
  }

  @media (max-width: 440px) {
    scale: 0.65;
    padding-top: 0 !important;
    margin-top: -55px;
  }
`;

const ContainerDetail = styled.div`
  margin: 0 36px;
  position: relative;
  z-index: 2;

  img {
    overflow-clip-margin: content-box;
    overflow: clip;
    vertical-align: inherit;
  }

  .container-bg-take-prize {
    .take-prize-main {
      width: max-content;
      margin: 0 auto;
    }
  }

  .icon-super-prize {
    position: absolute;
    z-index: 99;
    top: 62px;
    left: 20px;
    pointer-events: none;
    @media (max-width: 992px) {
      width: 40px;
    }
    @media (max-width: 576px) {
      top: 40px;
    }
  }

  .main-content__container.runout {
    position: relative;
    .w-max {
      .img-brightness {
        filter: brightness(0.25);
      }

      &::after {
        filter: brightness(0.4);
      }

      &::before {
        filter: brightness(0.4);
      }
    }
  }

  .runout-img {
    position: absolute;
    z-index: 9;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .bg-take-prize {
    height: 62px;
  }

  .container-bg-take-prize {
    position: relative;
  }

  .content-bg-take-prize {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    font-size: 24px;
    font-weight: 600;
  }

  .opcity-06 {
    opacity: 0.6;
    pointer-events: none;
  }

  .deleted {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: calc(100% - 50px);
    height: calc(100% - 50px);
    cursor: pointer;
    z-index: 4;
  }

  .img-brightness {
    filter: brightness(0.5);
  }

  .w-max::after {
    content: "";
    position: absolute;
    height: calc(100% - 4px);
    width: calc(100% - 4px);
    z-index: 2;
    width: 100%;
    background-color: white;
    left: 0;
    top: 0;
    pointer-events: none;
  }

  .w-max::before {
    z-index: 4 !important;
    pointer-events: none;
  }

  .w-max img {
    position: relative;
    z-index: 3;
  }

  .background-gradient {
    width: 100%;
    height: 100%;
    position: relative;
    &::before {
      content: "";
      pointer-events: none;
      position: absolute;
      .background-gradient {
        width: 8px;
        height: 100%; // Hoặc một giá trị cụ thể nếu cần
        background: linear-gradient(to bottom, #ffffff 0%, #a1dbfd 100%);
        border-radius: 16px;
      }
    }
  }

  .content-detail {
    @import url("https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Grechen+Fuemen&family=Karla:ital,wght@0,200..800;1,200..800&family=Lobster&family=Londrina+Solid:wght@100;300;400;900&family=Mulish:ital,wght@0,300;1,300&family=Noto+Sans+Myanmar:wght@100;200;300;400;500;600;700;800;900&family=Open+Sans:ital,wght@0,300..800;1,300..800&family=Shrikhand&family=Vina+Sans&display=swap");
    font-size: 32px;
    background: linear-gradient(to bottom, #ffffff 25%, #a5deff 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-weight: bold;
    position: absolute;
    z-index: 2;
    max-width: 100%;
    left: 50%;
    top: calc(50% - 10px);
    transform: translate(-50%, -50%);
    filter: drop-shadow(1px 0 0 #d9421c) drop-shadow(-1px 0 0 #d9421c)
      drop-shadow(0 3px 0 #d9421c) drop-shadow(0 -1px 0 #d9421c) !important;
    line-height: 1.5;
  }

  .img-bg {
    width: 100%;
    height: 100%;
    position: absolute;
    border-radius: 31px;
    border: 8px solid transparent;
    background: linear-gradient(to top, #efba43 0%, #fede80 100%) border-box;
  }

  .img-header-takeprize-mini {
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    top: 0;
    width: 765px;
    max-width: 90%;
    text-align: center;
  }

  .main-content {
    padding: 20px;
    padding-top: 40px;
    position: relative;
    top: 0;
    z-index: 1;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    text-align: center;
    margin-bottom: 30px;
  }

  .main-content__container {
    padding-top: 70px;
  }

  .bg-detail {
    width: 100%;
    height: 100%;
  }

  .content-product {
    position: relative;
  }

  .icon-winner__collect {
    width: 80px;
    z-index: 2;
    position: absolute;
    left: -20px;
    top: -3px;
  }

  .content-active {
    width: 100%;
    margin-top: 20px;
    text-align: center;
  }

  .content-container-prize1 {
    margin-top: -85px;
    margin-bottom: 55px;
  }

  .content-container-prize {
    margin-top: -35px;
    margin-bottom: 65px;
  }

  /* .content-container-prize-8 {
    margin-top: -72px;
  } */

  @media (max-width: 768px) {
    .content-container-prize1 {
      margin-top: -155px;
      margin-bottom: 55px;
    }

    .main-content__container {
      width: 565px;
    }

    .special-product {
      width: 650px;
    }

    .container-main__content {
      margin: 0 auto;
      display: flex;
      justify-content: center;
      scale: 0.9;
    }

    .content-container-prize-5 {
      margin-top: -125px;
    }

    .content-container-prize-8 {
      margin-top: -85px;
    }

    .content-detail {
      font-size: 28px;
    }
  }

  @media (max-width: 576px) {
    .content-container-prize1 {
      margin-top: -195px;
      margin-bottom: 55px;
    }

    .special-product {
      .img-child2__5, .img-child2__7{
        top: -40px;
      }

      .img-child2__6, .img-child2__8{
        top: -24px;
      }
    }

    .container-bg-take-prize {
      .take-prize-main {
        width: auto;
        margin: 0 auto;
        display: flex;
        justify-content: center;
      }

      .content-bg-take-prize {
        font-size: 18px;
      }
      .bg-take-prize {
        height: 54px;
      }
    }

    .icon-winner__collect {
      width: 60px;
    }

    .content-detail {
      font-size: 24px;
    }

    .icon-winner__collect {
      left: -5px;
      top: -8px;
    }

    .content-container-prize-8 {
      margin-top: -115px;
    }
  }

  @media (max-width: 512px) {
    .content-detail {
      font-size: 15px;
      top: calc(50% - 6px);
    }
  }

  @media (max-width: 440px) {
    margin: 0 8px;
    .content-container-prize {
      margin-bottom: 45px;
    }

    .content-container-prize {
      margin-top: -40px;
    }

    .content-container-prize-8 {
      margin-top: -115px;
    }
  }

  @media (max-width: 375px) {
    .content-detail {
      font-size: 18px;
    }
  }

  @media (max-width: 325px) {
    .content-detail {
      font-size: 16px;
      top: calc(50% - 4px);
    }
  }

  @media (min-width: 992px) {
    /* .main-content__container{
      height: 595px;
    } */
    .content-active {
      /* margin-top: -45px; */
    }

    .content-container-prize1 {
      margin-top: -108px;
      margin-bottom: 55px;
    }
  }

  @media (min-width: 1400px) {
    /* padding-left: 40px; */
    margin: 0 85px;
  }
`;
